<template>
  <StandardCard
    :divided="false"
    card-test-id="form-artifact-section"
  >
    <template #title>
      <div class="d-flex align-center justify-space-between ga-4 flex-wrap w-100">
        <span class="d-flex align-center ga-2 ws-pre-line fs-20 fw-800">
          {{ $bct('Form Artifact') }}
        </span>
      </div>
    </template>

    <div class="d-flex flex-column ga-4">
      <div class="d-flex flex-wrap align-center ga-2">
        <router-link
          v-if="formRoute"
          :to="formRoute"
          class="fs-16 text-wrap text-break min-w-0 c-primary underlined bc-link-hover"
          data-testid="form-artifact-name"
        >
          {{ formName }}
        </router-link>
        <span
          v-else
          class="fs-16 text-wrap text-break min-w-0"
          data-testid="form-artifact-name"
        >
          {{ formName }}
        </span>

        <StandardChip
          v-if="formStatus"
          :text="formStatus"
          role="status"
          size="small"
          capitalize
        />
      </div>
    </div>

    <template
      v-if="formRoute"
      #actions
    >
      <v-card-actions>
        <StandardButton
          :to="formRoute"
          data-testid="form-artifact-link"
          prepend-icon="open_in_new"
          role="secondary"
          text="View form"
          full-width
        />
      </v-card-actions>
    </template>
  </StandardCard>
</template>

<script setup>
import { useRouter } from 'vue-router';

const $bct = inject('translator');
const router = useRouter();

const props = defineProps({
  formArtifact: {
    type: Object,
    default: null,
  },
});

const formArtifactId = computed(() => props.formArtifact?.artifact_id ?? null);

const formName = computed(() => props.formArtifact?.form?.name || 'Form');

const formStatus = computed(() => props.formArtifact?.form?.status ?? null);

const formRoute = computed(() => {
  if (!formArtifactId.value) return null;
  if (!router?.hasRoute?.('FormShow')) return null;

  return {
    name: 'FormShow',
    params: { id: formArtifactId.value },
  };
});
</script>
